module.exports = "<div class=\"{{baCheckboxClass}}\">\r\n  <label class=\"checkbox-inline custom-checkbox nowrap\">\r\n    <input type=\"checkbox\" [checked]=state\r\n           (change)=\"onChange($event.target.checked)\"\r\n           [disabled]=\"disabled\" [value]=\"value\">\r\n    <span>{{label}}</span>\r\n  </label>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/framework/theme/components/baCheckbox/baCheckbox.html
// module id = ./src/framework/theme/components/baCheckbox/baCheckbox.html
// module chunks = main